import { render, staticRenderFns } from "./UploadHeader.vue?vue&type=template&id=69afc12c&scoped=true"
import script from "./UploadHeader.vue?vue&type=script&lang=js"
export * from "./UploadHeader.vue?vue&type=script&lang=js"
import style0 from "./UploadHeader.vue?vue&type=style&index=0&id=69afc12c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69afc12c",
  null
  
)

export default component.exports